module.exports = __webpack_public_path__ + "img/idea_text3.248c3a35.png";